<template>
  <div>
    <!-- 导航栏 -->
    <Nav />

    <!-- 资讯详情主体内容 -->
    <section class="mt-20 bg-white">
      <div class="max-w-4xl mx-auto px-4 py-8">
        <!-- 文章标题区域 -->
        <div class="mb-8">
          <h1 class="text-3xl font-bold text-gray-900 mb-4">
            {{ articleDetail.title }}
          </h1>

          <!-- 标签与日期 -->
          <div
            class="flex items-center space-x-4 flex-wrap text-sm text-gray-600 mb-4"
          >
            <span class="bg-blue-50 text-primary px-3 py-1 rounded-full">
              {{ articleDetail.category_name }}
            </span>
            <span
              v-if="articleDetail.is_recommend == 1"
              class="bg-green-50 text-green-600 px-3 py-1 rounded-full"
            >
              精选推荐
            </span>
            <span class="flex items-center">
              <i class="ri-calendar-line mr-1"></i>
              {{ $tool.formatDate(articleDetail.createtime, "YYYY-MM-DD") }}
            </span>
            <span v-if="articleDetail.view_count" class="flex items-center">
              <i class="ri-eye-line mr-1"></i>
              {{ articleDetail.view_count }} 阅读
            </span>
          </div>

          <!-- 文章摘要 -->
          <p
            class="text-gray-700 text-base leading-relaxed border-l-4 border-primary pl-4 italic"
          >
            {{ articleDetail.description }}
          </p>
        </div>
      </div>
    </section>

    <!-- 文章正文内容 -->
    <section class="py-8 bg-gray-50">
      <div class="max-w-4xl mx-auto px-4">
        <div class="bg-white rounded-xl shadow-sm overflow-hidden">
          <div class="p-8">
            <div
              class="prose max-w-none text-md leading-relaxed"
              v-html="articleDetail.content"
            ></div>
          </div>
        </div>
      </div>
    </section>



    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import { Message } from "element-ui";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import api from "@/utils/api.js";

export default {
  name: "ArticleDetail",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      articleDetail: null,
      loading: true,
      error: "",
      relatedArticles: [],
    };
  },
  mounted() {
    this.loadArticleDetail();
    this.loadRelatedArticles();
  },
  methods: {
    // 获取资讯详情
    async loadArticleDetail() {
      try {
        this.loading = true;
        this.error = "";
        const articleId = this.$route.params.id; // 使用路由参数作为资讯ID

        // 调用API获取资讯详情
        const response = await api.article.getDetail({ id: articleId });
        this.articleDetail = response.data;

        // 设置页面标题为资讯名称
        if (this.articleDetail && this.articleDetail.title) {
          document.title = `${this.articleDetail.title} - 资讯详情 - 会找我-专业会展设备租赁服务`;
        }
      } catch (err) {
        this.error = "资讯信息加载失败，请稍后重试";
        console.error("加载资讯详情失败:", err);
      } finally {
        this.loading = false;
      }
    },

    // 获取相关资讯
    async loadRelatedArticles() {
      try {
        const articleId = this.$route.params.id;

        // 调用API获取资讯列表，设置参数获取相关资讯
        const categoryId = this.articleDetail
          ? this.articleDetail.category_id
          : null;
        const response = await api.article.getList({
          category_id: categoryId,
          exclude_id: articleId, // 排除当前资讯
          page: 1,
          pageSize: 4, // 获取4个相关资讯
        });

        if (response.code === 200 && response.data && response.data.list) {
          this.relatedArticles = response.data.list;
        }
      } catch (err) {
        console.error("加载相关资讯失败:", err);
      }
    },

    // 分享文章
    shareArticle() {
      Message.success("分享链接已复制到剪贴板");
      // 实际项目中应该实现复制链接功能
    },

    // 在线咨询
    handleOnlineConsultation() {
      Message.success("正在连接客服，请稍候...");
    },

    // 跳转到其他资讯详情
    goToArticleDetail(articleId) {
      this.$router.push(`/article/${articleId}`);
    },
  },
};
</script>

<style scoped>
.mt-20 {
  margin-top: 5rem;
}

.prose {
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}

.prose h2 {
  color: #111827;
  font-size: 1.8rem;
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.prose h3 {
  color: #111827;
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.prose h4 {
  color: #111827;
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1.2rem;
  margin-bottom: 0.8rem;
}

.prose p {
  margin-bottom: 1.2rem;
  text-align: justify;
}

.prose img {
  max-width: 100%;
  height: auto;
  margin: 1.5rem auto;
  display: block;
}

.prose ul,
.prose ol {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.prose li {
  margin-bottom: 0.5rem;
  text-align: justify;
}

.prose a {
  color: #2563eb;
  text-decoration: none;
}

.prose a:hover {
  text-decoration: underline;
}

.prose blockquote {
  border-left: 4px solid #2563eb;
  padding-left: 1rem;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  color: #666;
}

/* 相关资讯样式 */
.related-article-card:hover {
  transform: translateY(-3px);
  transition: transform 0.3s ease;
}

.related-article-card h3:hover {
  color: #2563eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/article/ArticleDetail.vue